import Swiper from 'swiper';
import Navigation from 'swiper/modules/navigation.mjs';
import Autoplay from 'swiper/modules/autoplay.mjs';
import Parallax from 'swiper/modules/parallax.mjs';
import Pagination from 'swiper/modules/pagination.mjs';
import Keyboard from 'swiper/modules/keyboard.mjs';

import gsap from 'gsap';
import isMobile from 'ismobilejs';
import './functions/sizeSVG';
import './functions/share';
import './functions/contact';
import './functions/booxi_handler';
import './functions/accessibility';
import './functions/scrollDirection';
import 'add-to-calendar-button';

import scrollTo from './functions/scrollTo';
import toggleFn from './functions/toggle';
import accordionFn from './functions/accordion';
import {brandsFilter, searchForm} from './functions/search';
import isInViewport from './functions/in_viewport';

window.is_mobile = isMobile().phone || window.innerWidth <= 1024;

/*
* Fixing space issues in source's srcset with cloudinary
* */
const sources = document.querySelectorAll('figure source');

[...sources].map(source => {
  const srcset = source.getAttribute('srcset');

  source.setAttribute('srcset', srcset.replace(/\?_i=AA /g, '?_i=AA____').replace(/, /g, ',____').replace(/ /g, '%20').replace(/____/g, ' '));
});

window.addEventListener('DOMContentLoaded', () => {
  initSlider();
  scrollTo();
  toggleFn();
  storeMaps();
  bannerSlider();
  accordionFn();
  videoHandle();
  backToTop();
  headerHeight();
  openingHours();

  searchForm.init();
  brandsFilter.init();

  if (!window.is_mobile) { // load only on desktop
    newsletterPopin();
  }
  else {
    mobileAccessMenu();
    navigationMobile();
  }
});

window.addEventListener('scroll', (e) => {
  if (getComputedStyle(document.body).overflow !== 'hidden') {
    headerHeight();
  }
});

window.addEventListener('resize', () => {
  if (getComputedStyle(document.body).overflow !== 'hidden') {
    headerHeight();
  }
});

const initSlider = () => {
  const sliders = document.querySelectorAll('[data-swiper]');

  window.swiper = [];

  Object.values(sliders).map(slider => {
    const timer = 6000;

    const sliderOptions = {
      modules: [Navigation, Pagination, Autoplay, Parallax, Keyboard],
      slidesPerView: parseFloat(slider.dataset.swiperSlidesPerView) || 'auto',
      parallax: true,
      centeredSlides: slider.dataset.swiperCentered === 'true',
      initialSlide: slider.dataset.swiperInitial || 0,
      loop: slider.dataset.swiperLoop === 'true',
      loopAdditionalSlides: slider.dataset.swiperLoop === 'true' ? 1 : null,
      speed: parseFloat(slider.dataset.swiperSpeed) || 1000,
      allowTouchMove: slider.dataset.swiperAllowMove !== 'false',
      direction: slider.dataset.swiperVertical === 'true' ? 'vertical' : 'horizontal',
      height: parseFloat(slider.dataset.swiperHeight) || null,
      autoplay: slider.dataset.swiperAutoplay !== 'false' ? {
        delay: parseFloat(slider.dataset.swiperTimer) || timer,
        pauseOnMouseEnter: true,
        reverseDirection: slider.dataset.swiperReverse === 'true',
      } : false,
      navigation: slider.dataset.navigation !== 'false' ? {
        prevEl: slider.dataset.swiperPrev || '.swiper-button-prev', nextEl: slider.dataset.swiperNext || '.swiper-button-next',
      } : false,
      pagination: slider.dataset.swiperPagination ? {
        el: slider.dataset.swiperPaginationElement || '.swiper-pagination',
      } : false,
      keyboard: {
        enabled: true,
      },
    };

    if (slider.dataset.swiperMobile && !window.is_mobile) {
      return;
    }
    const swiper = new Swiper(slider, sliderOptions);
    window.swiper.push(swiper);

    //accessibility
    swiper.on('slideChangeTransitionEnd', e => {
      swiper.slides.map(slide => {
        if (slide.classList.contains('swiper-slide-active')) {
          return false;
        }

        const links = slide.querySelectorAll('a');
        [...links].map(link => link.setAttribute('tabindex', '-1'));
      });

      const link = swiper.slides[e.realIndex].querySelector('a.button--action');

      if (isInViewport(slider) && link) {
        link.setAttribute('tabindex', '0');
        link.focus();
      }
    });

    swiper.slides.map(slide => {
      if (slide.classList.contains('swiper-slide-active')) {
        return false;
      }

      const links = slide.querySelectorAll('a');
      [...links].map(link => link.setAttribute('tabindex', '-1'));
    });
  });

  const home_slider = document.querySelector('.home-events--slider');
  if (home_slider) {

    gsap.to(home_slider, .3, {
      opacity: 1,
    });
  }
};

/*
  Function name : headerHeight
  Description : Calculate wesbite's main header and banner header and set css variables values
 */
const headerHeight = () => {
  const header = document.querySelector('.main--header');
  const banner = document.querySelector('.header--banner');
  const alphaFilters = document.querySelector('.alphabetical--filter');
  const headerHeight = header.getBoundingClientRect().height;

  window.headerHeight = headerHeight; //Setting global variable to get headerHeight anywhere
  document.documentElement.style.setProperty('--header-height', headerHeight + 'px'); // setting header-height css variable
  document.documentElement.style.setProperty('--header-wrapper', headerHeight + 'px'); // setting header-height css variable

  if (banner) {
    const bannerHeight = banner.getBoundingClientRect().height;
    window.bannerHeight = bannerHeight;

    document.documentElement.style.setProperty('--banner-height', -(bannerHeight) + 'px'); // setting banner-height css variable
    document.documentElement.style.setProperty('--header-wrapper', headerHeight - bannerHeight + 'px'); // setting banner-height css variable
  }

  if (alphaFilters) {
    const filtersHeight = alphaFilters.getBoundingClientRect().height;
    window.filtersHeight = filtersHeight; //Setting global variable to get filtersHeight anywhere
    document.documentElement.style.setProperty('--filters-height', filtersHeight + 'px'); // setting filters-height css variable
  }
};

/*
  Function name : storeMaps
  Description : Handle the toggle gestures of the store map on brands, restaurant, services single pages
 */
const storeMaps = () => {
  const storeMaps = document.querySelector('.section--store-map');

  if (storeMaps) {
    const buttons = document.querySelectorAll('.map--infos [data-map]');

    if (buttons.length > 1) {
      [...buttons].map(button => {
        button.addEventListener('click', () => { // when clicking on a retail space buttons
          const to_show = document.querySelector(`[data-map-image="${button.dataset.map}"]`);
          const to_hide = document.querySelector('[data-map-image].toggled');
          const active_button = document.querySelector('[data-map].active');

          active_button.classList.remove('active');
          active_button.removeAttribute('aria-pressed');

          button.classList.add('active');
          button.setAttribute('aria-pressed', true);

          to_hide.classList.remove('toggled'); // we hide active frame
          to_show.classList.add('toggled');// we show the associate map frame
        });
      });
    }
  }
};

/*
  Function name : bannerSlider
  Description : Handle the banner slider on information on top of pages when enabled
 */
const bannerSlider = () => {
  const banner = document.querySelector('.header--banner');

  if (banner) {
    const slider = banner.querySelector('[data-swiper]');
    const paragraphs = banner.querySelectorAll('p');

    // We create a function that sets a fixed slider with according to the largest paragraph
    // We decided to create a function because it'll be called on load and on window resize
    const set_width_slider = () => {
      let max_width = 0;

      [...paragraphs].map(p => { // we map all the paragraphs of the slider
        const p_width = p.getBoundingClientRect().width;
        // On each loophole we compare the actual paragraph with to the previous one.
        // If this one is larger than the previous, we set the variable max_width with this new value.
        // If not, the max_width value stays the same as the previous loophole.
        max_width = max_width < p_width ? p_width : max_width;
      });

      gsap.set(slider, {
        width: max_width,
        onComplete: () => { // when the width is set to the slider, we show the slider and the buttons (prev,next)
          gsap.to([slider, '.swiper-button-prev', '.swiper-button-next'], .3, {
            opacity: 1,
          });
        },
      });
    };

    // Init the above function
    set_width_slider();
    window.addEventListener('resize', () => set_width_slider());
  }
};

/*
  Function name : videoHandle
  Description : Initialize the youtube videos to show them only on click
 */
const videoHandle = () => {
  const controls = document.querySelectorAll('.video-controls'); // getting the controls (play button)

  Object.values(controls).map(control => {
    control.addEventListener('click', () => {
      const iframeWrapper = control.closest('.media-video').querySelector('.video-responsive');
      const iframe = iframeWrapper.dataset.video; // the iframe is not loaded directly on the code, but stored on the data-attribute "video"

      // This part parses the iframe string to turn it into an HTML element
      const parser = new DOMParser();
      const html = parser.parseFromString(iframe, 'text/html');
      const video = html.querySelector('body').children[0];

      video.src = video.src + '&autoplay=1'; // enabling autoplay so the iframe launches directly when the code is injected (on click)

      iframeWrapper.append(video); // injecting the iframe code
    });
  });
};

/*
  Function name : backToTop
  Description : scrolls back to top when clicking the right button
 */
const backToTop = () => {
  const button = document.getElementById('back_to_top');

  button.addEventListener('click', () => {
    const menu = document.querySelectorAll('.header--wrapper button')[0];
    window.scrollTo(0, 0); // go back to top

    setTimeout(() => menu.focus(), 1000); // for the accessibility, we focus the first button / link of the header
  });
};

/*
  Function name : mobileAccessMenu
  Description : show/hide the mobile quick access menu on scroll
 */
const mobileAccessMenu = () => {
  const nav = document.querySelector('.navigation--quick-access');

  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollDirection === 'down');
    });
  }
};

/*
  Function name : newsletterPopin
  Description : newsletter handle
 */
const newsletterPopin = () => {
  const popin_button = document.querySelector('[data-toggle="newsletter"]');

  if (window.location.hash === '#newsletter') {
    popin_button.click();
  }
};

/*
  Function name : openingHours
  Description : Updating store status for opened/closed feature on header
 */
const openingHours = () => {
  const now = new Date();
  const now_time = now.getTime(); // actual timestamp
  const opening_hours = document.querySelector('.opening--hours');

  if (opening_hours) {
    const opening = new Date(new Date(opening_hours.dataset.openingHours).setDate(now.getDate()));
    const opening_time = opening.getTime(); // Opening timestamp
    const closing = new Date(new Date(opening_hours.dataset.closingHours).setDate(now.getDate()));
    const closing_time = closing.getTime(); // Closing timestamp
    let status = 'Opened'; // by default, status is set to opened

    const nearly_closing = new Date(closing.setHours(closing.getHours() - 1));
    const nearly_closing_time = new Date(nearly_closing).getTime(); // Timestamp for nearly closed time

    if (now_time < nearly_closing_time && now_time > opening_time) {
      status = 'Opened';
    }
    else {
      if (now_time > nearly_closing_time && now_time < closing_time) {
        status = 'Closing';
      }
      else {
        if (now_time < opening_time && now.getHours() >= 0) {
          status = 'Closed'; // If the store is closed and will soon open
        }
        else {
          status = 'Tomorrow'; // Tomorrow status means store is closed and will open tomorrow
        }
      }
    }

    opening_hours.dataset.status = status.toLowerCase();

    const status_text = opening_hours.querySelector('span');
    status_text.innerText = opening_hours.dataset[`message${status}`];
  }
};

/*
  Function name : navigationMobile
  Description : Handling the mobile gesture of main navigation
 */
const navigationMobile = () => {
  const burger_button = document.querySelector('.button--burger');
  const open_label = burger_button.dataset.labelOpen;
  const close_label = burger_button.dataset.labelClose;

  //On click on burger button we toggle the active status on the button
  burger_button.addEventListener('click', () => {
    burger_button.setAttribute('aria-label', !burger_button.classList.contains('active') ? open_label : close_label);
  });

  const navigation_children = document.querySelectorAll('.main--navigation .navigation--children:not(.toggled)');

  [...navigation_children].map(item => {
    const links = item.querySelectorAll('a, button');
    [...links].map(link => link.setAttribute('tabindex', -1)); // disabling focus visible on sub elements of the nav
    item.setAttribute('aria-hidden', true); // Hiding it from screen readers

    const toggle_buttons = document.querySelectorAll(`[data-toggle="${item.dataset.toggleElement}"]`);

    [...toggle_buttons].map(button => {
      button.addEventListener('click', () => {
        const hidden = !item.classList.contains('toggled');

        [...links].map(link => link.setAttribute('tabindex', hidden ? -1 : 0));
      })
    })
  })
}
